(function () {
  'use strict';

  angular.module('sempraWebapp').factory('campaignActions', campaignActionsFactory);

  /** @ngInject */
  function campaignActionsFactory ($q, api, dispatcher, ActionTypesEnum, $translate) {
    return {
      getCampaigns: getCampaigns,
      getCampaignById: getCampaignById,
      createCampaign: createCampaign,
      updateCampaign: updateCampaign,
      deleteCampaign: deleteCampaign,
      getLoyaltyTresholds: getLoyaltyTresholds,
      activateCampaign: activateCampaign,
      sendCampaignUsersMessage : sendCampaignUsersMessage
    };

    function activateCampaign (campaignId) {
      var deferred = $q.defer();

      api.activateCampaign(campaignId).then(function (data) {
        dispatcher.dispatch({
            type: ActionTypesEnum.SHOW_TOASTER_MSG,
            payload: {
              type : ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
              message : $translate.instant('LOYALTY_ACTIVATE_CAMPAIGN_NOTIFICATION')
            }
        });
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

    function getLoyaltyTresholds (campaignId, type, tresholdValue, fromTimestamp, toTimestamp) {
      var deferred = $q.defer();

      api.getLoyaltyTresholds(campaignId, type, tresholdValue, fromTimestamp, toTimestamp).then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

    function sendCampaignUsersMessage(campaignId, tresholdValue, type, msg){
      var deferred = $q.defer();

      api.sendMessageToCampaignUsers(campaignId, tresholdValue, type, msg).then(function (data) {
        dispatcher.dispatch({
            type: ActionTypesEnum.SHOW_TOASTER_MSG,
            payload: {
              type : ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
              message : $translate.instant('LOYALTY_SENT_MESSAGE_NOTIFICATION')
            }
        });
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

    function getCampaigns () {
      var deferred = $q.defer();

      api.getCampaigns().then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

    function getCampaignById (campaignId) {
      var deferred = $q.defer();

      api.getCampaignById(campaignId).then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

    function createCampaign (campaign) {
      var deferred = $q.defer();

      api.createCampaign(campaign).then(function (data) {
        dispatcher.dispatch({
            type: ActionTypesEnum.SHOW_TOASTER_MSG,
            payload: {
              type : ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
              message : $translate.instant('LOYALTY_CREATE_CAMPAIGN_NOTIFICATION')
            }
        });
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

    function updateCampaign (campaign) {
      var deferred = $q.defer();

      api.updateCampaign(campaign).then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

    function deleteCampaign (campaignId) {
      var deferred = $q.defer();

      api.deleteCampaign(campaignId).then(function (data) {
        dispatcher.dispatch({
          type: ActionTypesEnum.SHOW_TOASTER_MSG,
          payload: {
            type : ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
            message : $translate.instant('DELETE_ITEM_SUCCESS')
          }
        });
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

  }
})();
